<template>
    <b-overlay :show="true" no-wrap variant="white" opacity="1" blur="50px">
        <template #overlay>
            <section class="overlay-content">
                <div class="spinner-border text-info" role="status"></div>
                <p>{{msg}}</p>
            </section>
        </template>
        <slot></slot> 
    </b-overlay>
</template>
<script>
export default{
    name: 'CustomLoading',
    props:{
        msg:String
    }
}
</script>
<style>
.overlay-content{
    display: flex;
    flex-direction: column;
    row-gap: 0.8rem;
    align-items: center;
    justify-content: center;
}

.overlay-content p{
    font-size: 1.5rem;
    font-weight: 500;

}
</style>